<div class="mx-md">
  <div
    class="mx-xxs hover:bg-background-underground-2 p-xs group/item flex cursor-pointer items-center justify-between rounded-md"
    (click)="toggle()"
  >
    <div class="flex w-full items-center justify-between">
      <div class="flex items-center" [style.width]="width()">
        <button
          [attr.aria-label]="(isOpen() ? 'Plier' : 'Déplier') + ' le bloc'"
          [hlmTooltipTrigger]="(isOpen() ? 'Plier' : 'Déplier') + ' le bloc'"
          hlmBtn
          variant="ghost"
          size="icon"
          type="button"
        >
          <ng-icon class="collapse-icon" [class.transform-[rotate(90deg)]]="isOpen()" name="lucideChevronRight" />
        </button>
        <p class="component-medium-semibold truncate">{{ titre() }}</p>
      </div>
      @if (actions()?.length) {
        <div class="invisible group-hover/item:visible">
          <button
            [hlmDropdownMenuTrigger]="actionsMenu"
            [hlmDropdownMenuTriggerData]="{
              $implicit: { item: item() },
            }"
            (click)="$event.stopPropagation()"
            hlmBtn
            variant="ghost"
            size="icon"
          >
            <ng-icon name="lucideEllipsisVertical" />
          </button>
        </div>
      }
      <ng-content select="etat" />
    </div>
  </div>
  @if (isOpen()) {
    <div @expandCollapse>
      <ng-content />
    </div>
  }
</div>

<ng-template #actionsMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of actions(); track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
        @if (action.shortcut) {
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        }
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
